/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from '../styles';
import { Course } from 'src/@types/Course';
import CourseNewEditForm from 'src/sections/@dashboard/course/courseNewEditForm';

export const CourseModal = ({
  open,
  handleClose,
  isEdit,
  currentCourse,
}: {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentCourse: Course | undefined;
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <CourseNewEditForm
          handleClose={handleClose}
          isEdit={isEdit}
          currentCourse={currentCourse}
        />
      </StyledModalBox>
    </Modal>
  );
};
